/* Lunaice: ruch przy przewijaniu (kierunek „Włącznik”, 2026-10-16). Bez bibliotek, ładowany z defer w theme.liquid.
   Element z data-ln-motion dostaje data-ln-state: pending (czeka pod ekranem; CSS ukrywa treść albo daje kolor dnia),
   potem run (CSS odgrywa animację raz), a gdy animacje się skończą, atrybut znika i element wraca do zwykłych stylów.
   - dusk: zmierzch w sekcji lunaice-final, start gdy góra sekcji minie 75 % wysokości ekranu. Stan trafia też na <html>
     (data-ln-dusk), bo razem z zakończeniem ciemnieje cała noc pod nim: sekcje main po nim (newsletter) i grupa stopki;
   - grid: wejście kafli siatki produktów, start przy 85 %;
   - moon: rozjaśnienie półksiężyca w wielkim logo stopki, start gdy widać połowę logo; raz na sesję (sessionStorage,
     audyt 2026-10-18, A12): na następnych stronach półksiężyc stoi już jasny;
   - dark (2026-10-26, przegląd telefonu, punkt 8): para „Po zmroku” na telefonie gaśnie sama, gdy 60 % kadru jest
     w kadrze, po 400 ms – przez pigułkę pary (LunaiceSwitch.set, bez komunikatu aria-live); raz na sesję; nie wtedy,
     gdy strona jest już w nocy ani na komputerze (tam oba kadry stoją obok siebie). Pigułka dalej działa w obie strony.
   Nic się nie dzieje (element stoi w stanie końcowym) bez IntersectionObserver, w edytorze motywu, przy
   prefers-reduced-motion: reduce i dla elementu, który przy starcie jest choć trochę w kadrze albo nad nim.
   Wejście na stronę z kotwicą w adresie, skok za element (kotwica, przywrócenie przewinięcia, klawisz End) i fokus
   z klawiatury w środku = stan końcowy od razu, bez animacji. Czasy, krzywe i kolory są w lunaice.css. */
(() => {
  // iOS Safari ustawia :active (nacisk na kafle i zdjęcia „Na niej”, lunaice.css) dopiero przy słuchaczu touchstart
  document.addEventListener('touchstart', () => {}, { passive: true });

  if (!('IntersectionObserver' in window)) return;
  const root = document.documentElement;
  if (root.classList.contains('shopify-design-mode')) return;
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  // wejście z kotwicą (np. po zapisie do newslettera albo z linku do #prezenty): przeglądarka skacze, więc bez ruchu
  if (window.location.hash) return;

  // Górny margines korzenia: element przeskoczony w górę też „przecina” obszar, więc nie zostaje w pending.
  const ABOVE = '100000px';
  // margin: przesunięcie dolnej krawędzi obszaru (linia startu), threshold: część elementu w obszarze,
  // jump: jeśli w chwili startu góra elementu jest wyżej niż ta część ekranu, to był skok i animacji nie ma,
  // page: stan idzie też na <html> i obejmuje noc pod elementem (style w lunaice.css),
  // once: klucz w sessionStorage – animacja raz na sesję karty przeglądarki.
  const KINDS = {
    dusk: { margin: '-25%', threshold: 0, jump: 0.4, page: 'lnDusk', once: null },
    grid: { margin: '-15%', threshold: 0, jump: 0, page: null, once: null },
    moon: { margin: '0px', threshold: 0.5, jump: 0, page: null, once: 'ln-moon' },
    dark: { margin: '0px', threshold: 0.6, jump: 0, page: null, once: 'ln-dark', act: darken },
  };

  // zwraca true, gdy zgaszenie naprawdę ruszyło (tylko wtedy zapisujemy „raz na sesję”)
  function darken(el) {
    if (!window.matchMedia('(max-width: 749px)').matches) return false;
    if (!window.LunaiceLight || window.LunaiceLight.state === 'night') return false;
    const pill = el.querySelector('lunaice-switch');
    if (!pill || typeof pill.set !== 'function') return false;
    window.setTimeout(() => {
      if (el.dataset.state !== 'night') pill.set('night');
    }, 400);
    return true;
  }

  // sessionStorage bywa niedostępne (tryb prywatny, zablokowane dane strony): wtedy animacja jak dotąd, za każdym razem
  const seen = (key) => {
    try {
      return window.sessionStorage.getItem(key) === '1';
    } catch {
      return false;
    }
  };
  const remember = (key) => {
    try {
      window.sessionStorage.setItem(key, '1');
    } catch {
      // bez zapisu: następna strona pokaże animację jeszcze raz
    }
  };

  // sekcje main po sekcji elementu i grupa stopki: tam CSS przyciemnia nocne tła razem z zakończeniem
  const nightBelow = (el) => {
    const nodes = [];
    let section = el.closest('.shopify-section');
    while (section && (section = section.nextElementSibling)) {
      if (section.classList.contains('shopify-section')) nodes.push(section);
    }
    return nodes.concat(Array.from(document.querySelectorAll('.shopify-section-group-footer-group')));
  };

  for (const el of document.querySelectorAll('[data-ln-motion]')) {
    const kind = KINDS[el.dataset.lnMotion];
    if (!kind) continue;
    if (kind.once && seen(kind.once)) continue;
    if (el.getBoundingClientRect().top < window.innerHeight) continue;

    const zone = kind.page ? [el, ...nightBelow(el)] : [el];
    const setState = (state) => {
      if (state) el.dataset.lnState = state;
      else delete el.dataset.lnState;
      if (!kind.page) return;
      if (state) root.dataset[kind.page] = state;
      else delete root.dataset[kind.page];
    };

    const run = () => {
      if (kind.act) {
        setState(null);
        if (kind.act(el) && kind.once) remember(kind.once);
        return;
      }
      setState('run');
      if (kind.once) remember(kind.once);
      // getAnimations przelicza style, więc zwraca animacje CSS nowego stanu (razem z pseudoelementami)
      const animations = zone.flatMap((node) =>
        typeof node.getAnimations === 'function' ? node.getAnimations({ subtree: true }) : []
      );
      const done = () => setState(null);
      if (!animations.length) {
        done();
        return;
      }
      Promise.all(animations.map((animation) => animation.finished)).then(done, done);
    };

    setState('pending');
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[entries.length - 1];
        if (!entry.isIntersecting) return;
        observer.disconnect();
        if (entry.boundingClientRect.top < window.innerHeight * kind.jump) setState(null);
        else run();
      },
      { rootMargin: `${ABOVE} 0px ${kind.margin} 0px`, threshold: kind.threshold }
    );
    observer.observe(el);

    const reveal = () => {
      if (el.dataset.lnState !== 'pending') return;
      observer.disconnect();
      setState(null);
    };
    for (const node of zone) node.addEventListener('focusin', reveal);
  }
})();
